import React from 'react';

import { useTranslation } from 'react-i18next';
import { showDialogAction } from 'components/redux-dialog/actions';
import { DialogDecorated, DialogBody, DialogFooter, DialogTitle } from 'components/redux-dialog';
import { Button } from 'components/button';
import { hideDialogAction } from 'components/redux-dialog/actions';
import { useDispatch } from 'react-redux';

const CONFIRMATION_DIALOG = 'confirmation-dialog';

export const openConfirmationDialog = () => showDialogAction(CONFIRMATION_DIALOG);

export const ConfirmationDialog = ({
  handleClose,
  title,
  body,
  okLabel = 'ok',
  cancelLabel = 'cancel',
  dialogName,
  onOpen,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onClose = (ok) => {
    dispatch(hideDialogAction(dialogName));
    if (handleClose) {
      handleClose(ok);
    }
  };

  return (
    <DialogDecorated data-e2e="confirmation-dialog" dialogName={dialogName} onOpen={onOpen}>
      <DialogTitle handleClose={() => onClose(false)}>{t(title)}</DialogTitle>
      <DialogBody>{t(body)}</DialogBody>
      <DialogFooter>
        <div className="d-flex justify-content-end">
          <Button secondary onClick={() => onClose(false)}>
            {t(cancelLabel)}
          </Button>

          <div className="ml-3">
            <Button onClick={() => onClose(true)}>{t(okLabel)}</Button>
          </div>
        </div>
      </DialogFooter>
    </DialogDecorated>
  );
};
